'use client';

import styled from 'styled-components';

import type { HeadingFourElementType } from '@zoomit/editor';
import { Typography } from '@zoomit/zoomit-ds';

interface RenderElementProps {
  children: any;
  element: HeadingFourElementType;
  id?: string;
}

const HeadingFour = (props: RenderElementProps) => {
  const { children, element } = props;

  return (
    <HeadingFourBase
      variant="h4"
      lineHeight={1.78}
      textAlign={element.annotations.textAlign}
      textDir={element.annotations.textDirection}
    >
      {children}
    </HeadingFourBase>
  );
};

export default HeadingFour;

type HeadingFourProps = {
  textAlign?: string;
  textDir?: string;
};

const HeadingFourBase = styled(Typography)<HeadingFourProps>`
  font-size: 1.8rem;
  margin: 0;
  text-align: ${({ textAlign }) => textAlign};
  direction: ${({ textDir }) => textDir};
`;
